import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type TaskCreationConfigFileQueryVariables = Types.Exact<{
  fileId: Types.Scalars['String']['input'];
}>;


export type TaskCreationConfigFileQuery = { file?: { id: string, taskCreationConfigs?: Array<{ id: string, actionItemsLinkedCount: number, searchText?: string | null, createdByUser?: { name?: string | null, id: string } | null, syncConfig?: { syncStatus: Types.SyncStatusEnum } | null }> | null } | null };


export const TaskCreationConfigFileDocument = /*#__PURE__*/ gql`
    query taskCreationConfigFile($fileId: String!) {
  file(filters: {id: $fileId}) {
    id
    taskCreationConfigs {
      id
      createdByUser {
        name
        id
      }
      actionItemsLinkedCount
      searchText
      syncConfig {
        syncStatus
      }
    }
  }
}
    `;

export function useTaskCreationConfigFileQuery(options: Omit<Urql.UseQueryArgs<TaskCreationConfigFileQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskCreationConfigFileQuery, TaskCreationConfigFileQueryVariables>({ query: TaskCreationConfigFileDocument, ...options });
};